import {TableColumn} from '@vidazoo/ui-kit';
import {IChangeLog} from '../interfaces/IChangeLog';

export const ChangeLogsTableColumns: TableColumn<IChangeLog>[] = [
    {
        title: 'Scope',
        key: 'scope',
        defaultWidth: 100,
        options: {search: {searchKey: 'scope'}, freeze: true, sort: {sortKey: 'scope'}}
    },
    {
        title: 'Account',
        key: 'account',
        defaultWidth: 100,
        options: {search: {searchKey: 'account'}, freeze: true, sort: {sortKey: 'account'}}
    },
    {
        title: 'User',
        key: 'user',
        defaultWidth: 100,
        options: {freeze: true}
    },
    {
        title: 'Action',
        key: 'action',
        defaultWidth: 100,
        options: {search: {searchKey: 'action'}, freeze: true, sort: {sortKey: 'action'}}
    },
    {
        title: 'Model Name',
        key: 'model_name',
        defaultWidth: 100,
        options: {search: {searchKey: 'model_name'}, freeze: true, sort: {sortKey: 'model_name'}}
    },
    {
        title: 'Model ID',
        key: 'model_id',
        defaultWidth: 100,
        options: {search: {searchKey: 'model_id'}, freeze: true, sort: {sortKey: 'model_id'}}
    },
    {
        title: 'Date',
        key: 'date',
        defaultWidth: 100,
        options: {freeze: true, sort: {sortKey: 'date'}}
    },
    {
        title: 'Diff',
        key: 'diff',
        defaultWidth: 100,
    }
];
